var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state.getContactGroupID() != 2
    ? _c("app-sale-vat-regime-select", {
        attrs: {
          value: _vm.state.sale.VatRegime,
          label: _vm.$ct("vat-regime"),
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _c("app-purchase-vat-regime-select", {
        attrs: {
          value: _vm.state.sale.VatRegime,
          label: _vm.$ct("vat-regime"),
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }